// extracted by mini-css-extract-plugin
module.exports = {"color-primary":"#d11a22","color-title":"#000","color-content":"#5c5c5c","font-zh":"\"Source Han Sans CN\"","font-en":"\"Noto Serif\",serif"};